import { getUser } from '../../shared/auth-service';
import { getAirports } from '../../shared/data-services/airport-service';
import { getUserData } from '../../shared/info-device';
import { 
    getActiveShifts,
    sendNewShift,
    sendDeleteShift,
    sendUpdateShift,
    getCheckShiftCodeExistence
} from '../../shared/data-services/shift-service';
import { AirportShuttle } from '@mui/icons-material';

export async function getAllAirports (companyId){
     const data = await getAirports(companyId);
    //const { airport } = getUser();

    // return [airport];
    return data;
};

export async function getShiftType(){
    return [
        {id: 0, description: 'Completo'},
        {id: 1, description: 'Horas / Fracción'},
        {id: 2, description: 'Flexible'},
        {id: 3, description: 'Novedad'}
    ];
};

export async function getShifts(companyId){
    const { airports } = getUser();

    const airportIds = airports.map(a => a.id);
    
    const params = {isActive: true, airportId: airportIds, companyId: companyId };
    const data = await getActiveShifts(params);
    return data;
};

export async function saveNewShift(code, externalShiftCode, descriptionShift, shiftType, shiftAssignment, companyId){
    const { employeeId: user } = getUser();
    const userAgent = navigator.userAgent;
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const params = { code, externalShiftCode, descriptionShift, shiftType, shiftAssignment, userAgent, user, ip };

    const data = await sendNewShift(params, companyId);
    return data.data;
};

export async function deleteShift(shiftId){
    const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const userAgent = navigator.userAgent;

    const params = { shiftId, userAgent, user, ip }
    const data = await sendDeleteShift(params);
    return data;
};

export async function saveUpdateShift(dataEdit, companyId){
    const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const userAgent = navigator.userAgent;
    const params = {...dataEdit, userAgent, user, ip};

    const data = await sendUpdateShift(params, companyId);
    return data;
};

export async function GetCheckShiftCodeExistence (code, companyId){
    const data = await getCheckShiftCodeExistence(code, companyId);
    return data;
};